import React from 'react';
import { Route } from 'react-router';
import LoteRouteSwitch from './lote/LoteRouteSwitch';
import LanguageLearningRouteSwitch from './languagelearning/LanguageLearningRouteSwitch';
import { BundlesRouteSwitch } from './bundles/BundlesRouteSwitch';
import { MULTI_LANGUAGE_SHOP, useFeature } from '../../shared/utils/togglz';
import { Navigate, Routes } from 'react-router-dom';

const RouteSwitch = () => {
    const isMultiLanguageShopEnabled = useFeature(MULTI_LANGUAGE_SHOP);

    return (
        <Routes>
            <Route index element={<Navigate to="lote" replace />} />
            <Route
                path="lote/*"
                element={isMultiLanguageShopEnabled ? <Navigate to="/shop/other" replace /> : <LoteRouteSwitch />}
            />
            <Route path="languagelearning/*" element={<LanguageLearningRouteSwitch />} />
            <Route
                path="bundles/*"
                element={
                    isMultiLanguageShopEnabled ? <Navigate to="/shop/other/bundles" replace /> : <BundlesRouteSwitch />
                }
            />
        </Routes>
    );
};

export default RouteSwitch;
